import React from 'react';
import '../scss/components/_basic-hero.scss'

const BasicHero = props => (

    <section className="d-flex flex-column contentBlock">
        <div>
            <h1 className="text-center hero-title">{props.title}</h1>
            <p className="text-center header-p mb-0">{props.subtitle} </p>
        </div>
    </section>
);

export default BasicHero;
    